import axios from "axios";

import {
  HELP_OVERLAY_URL,
  PRODUCT,
  APPLICATION,
  SECONDARY_PRODUCT,
} from "@/constants";

const fetchHelpOverlay = async (
  risk: "lowRisk" | "mediumRisk" | "highRisk" | "veryHighRisk"
) => {
  let pageJson;
  if (APPLICATION === "renewal") {
    await axios
      .get(`${HELP_OVERLAY_URL}/${PRODUCT}-${APPLICATION}/${risk}`)
      .then(async (res) => {
        pageJson = res.data;
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((e) => {
        pageJson = {};
      });
    return pageJson;
  }
  const fetchURL = `${HELP_OVERLAY_URL}/${SECONDARY_PRODUCT || PRODUCT}/${risk}`;
  await axios
    .get(fetchURL)
    .then(async (res) => {
      pageJson = res.data;
    })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .catch((e) => {
      pageJson = {};
    });
  return pageJson;
};

export default fetchHelpOverlay;
